import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../../utils/Button';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    console.log(item);
    const navigate = useNavigate();
    const [isTrActive, setIsTrActive] = useState(false);
    const handleView = (e) => {
        e.stopPropagation();
        navigate(mkRelativeUrl(`/billing/invoices/${item.invoiceId}/info`));
    };
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.invoiceId}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.subscriptionName}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">
                        {item?.customerInfo?.organization}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Organization"
                    value={item?.customerInfo?.organization}
                    className="sm:hidden"
                />
                <TableInfoCard name="Email" value={item?.customerInfo?.primaryEmail} />
                <TableInfoCard name="Limit By" value={item?.limitBy || '-----'} />
                <TableInfoCard
                    name="Inst. Date"
                    value={GetDate(item?.timeFirstInstallation) || 'No Installation Date'}
                />
                <TableInfoCard
                    name="Subs. Start"
                    value={GetDate(item?.timeSubscriptionStart) || '---'}
                />
                <TableInfoCard
                    name="Subs. End"
                    value={GetDate(item?.timeSubscriptionEnd) || '---'}
                />
                <TableInfoCard
                    name="Subs. Status"
                    value={item?.status && <span className="text-warning">{item?.status}</span>}
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary btnType="button" title="View" onClick={handleView} />
                </div>
            </div>
        </div>
    );
}
function ServicePendingTableMobile({ data }) {
    return (
        <div className="subscription_pending_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data?.subscriptions && data?.subscriptions?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.subscriptions?.map((item) => (
                        <TableRow key={item.invoiceId} item={item} />
                    ))
                )}
            </div>
        </div>
    );
}

export default ServicePendingTableMobile;
